import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { TmBaseComponent } from '../../tm-base.component';

export const tagName = 'tm-content';
@customElement(tagName)
export class TmContent extends TmBaseComponent {
    protected render() {
        return html`<slot></slot>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-direction: column;
                    row-gap: 0.625rem;
                    box-shadow: var(--content-shadow);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmContent;
    }
}
